import React from "react";
import { useModal } from "../../../components/ContextApi/modal/modalContext";
import DraggableProgressBar from "../../../components/Common/commonProgressBar";

const Step2 = ({
  step,
  setStep,
  age,
  setAge,
  ethnicBackground,
  setEthnicBackground,
  appearanceList,
  appearanceLoading,
}) => {
  const canProceed = age && ethnicBackground;
  return (
    <>
      <div className="mx-auto lg:max-w-[100%] max-w-[800px] flex flex-col gap-4">
        {/* <div className="text-center">
          <h4 className="m-0 text-[20px]">CREATE YOUR AI CHARACTER</h4>
          <p className="m-0 py-2 font-normal">Take Control of your Character</p>
        </div> */}
        <div className="">
          <div className="text-center pb-3">
            <h6 className="m-0 py-2 font-semibold text-[20px] capitalize">
              {appearanceList?.age?.[0]?.name}
            </h6>
          </div>
          <div className="flex items-center justify-center gap-3 flex-wrap mb-5 max-w-[400px] mx-auto">
            {/* {["18+", "20s", "30s", "40s", "50s", "Custom"].map((item, key) => (
              <div key={key} className="relative">
                <input
                  type="radio"
                  name="age"
                  onChange={
                    item === "Custom"
                      ? () =>
                          openModal("custom-add-label-pop", {
                            label: "Add Age",
                            field: "age",
                          })
                      : undefined
                  }
                  className="absolute peer top-0 left-0 w-full h-full z-[9] cursor-pointer opacity-0"
                />
                <div className="h-[41px] peer-checked:border-[#e343a5] text-[#838383] border border-[#ddd] flex items-center justify-center rounded-[8px] px-3 min-w-[96px] peer-checked:bg-[#e343a5] peer-checked:text-white font-medium">
                  {item}
                </div>
              </div>
            ))} */}
            <div className="h-[41px] bg-[linear-gradient(263deg,#b46cff,#ff5fd1)] text-white text-[#E7E6F8]   flex items-center justify-center rounded-[8px] p-[1px] min-w-[96px] mb-3">
              {age}
            </div>

            <DraggableProgressBar
              value={((age - 18) / (60 - 18)) * 100}
              onChange={(v) => {
                const newAge = Math.round(18 + (v / 100) * (60 - 18));
                setAge(String(newAge)); // 🔥 SAME KEY AS BEFORE
              }}
            />
          </div>
        </div>
        <div className="">
          <div className="text-center pb-3">
            <h6 className="m-0 py-2 font-semibold text-[20px] capitalize">
              {appearanceList?.ethnicBackground?.[0]?.name}
            </h6>
          </div>
          <div
            className={`${
              appearanceList?.ethnicBackground?.[0]?.options?.length <= 6
                ? "lg:flex justify-center"
                : "lg:grid-cols-6"
            } grid gap-2 grid-cols-12 w-full`}
          >
            {appearanceList?.ethnicBackground?.[0]?.options?.map(
              (item, key) => (
                <div
                  key={item.id}
                  className="lg:col-span-1 md:col-span-3 sm:col-span-4 col-span-6 relative w-full"
                >
                  <input
                    type="radio"
                    name="bg"
                    value={item.name}
                    checked={ethnicBackground === item.name}
                    onChange={(e) => {
                      setEthnicBackground(e.target.value);
                    }}
                    className="absolute peer top-0 left-0 w-full h-full z-[99] cursor-pointer opacity-0"
                  />
                  <span className="absolute top-3 right-3 text-white opacity-40 peer-checked:opacity-100 z-[9]">
                    {checkIcn}
                  </span>
                  <div className="relative peer-checked:border-[#e343a5] border-[4px] border-white/30 rounded-[12px]">
                    {item.video && item.video.trim() !== "" ? (
                      <video
                        src={item.video}
                        poster={
                          item.image && item.image.trim() !== ""
                            ? item.image
                            : undefined
                        }
                        height={1000}
                        width={1000}
                        style={{ aspectRatio: 249 / 332 }}
                        className="max-w-full h-auto w-full object-cover object-top rounded-[8px]"
                        muted
                        loop
                        autoPlay
                        playsInline
                      />
                    ) : item.image && item.image.trim() !== "" ? (
                      <img
                        src={item.image}
                        alt=""
                        height={1000}
                        width={1000}
                        style={{ aspectRatio: 249 / 332 }}
                        className="max-w-full h-auto w-full object-cover object-top rounded-[8px]"
                      />
                    ) : null}
                  </div>
                  <div className="mt-1 text-center px-5 py-1 rounded-full peer-checked:bg-white max-w-[max-content] mx-auto peer-checked:text-black">
                    <p className="m-0 inline-block text-[12px] font-medium leading-tight">
                      {item.title.title}
                    </p>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
        <div className="mt-[80px] mx-auto max-w-[516px] w-full">
          <button
            disabled={!canProceed}
            onClick={() => canProceed && setStep(4)}
            className={`${!canProceed && "opacity-50 cursor-not-allowed"} flex items-center justify-center gap-2 h-[45px] bg-[#E443A6] w-full px-3 rounded-[10px] text-white font-medium`}
          >
            Next {rightIcn}
          </button>
        </div>
      </div>
    </>
  );
};

export default Step2;

const rightIcn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 10.0013C17.5 10.4613 17.1267 10.8346 16.6667 10.8346H3.33333C2.87333 10.8346 2.5 10.4613 2.5 10.0013C2.5 9.5413 2.87333 9.16797 3.33333 9.16797H16.6667C17.1267 9.16797 17.5 9.5413 17.5 10.0013Z"
      fill="white"
    />
    <path
      d="M15.8115 10.0002C15.734 9.87103 15.5707 9.63936 15.3923 9.4377C15.0382 9.03603 14.549 8.5777 14.0382 8.13436C13.5323 7.6952 13.0232 7.28686 12.6398 6.98686C12.4482 6.8377 12.1182 6.58853 12.0073 6.50436C11.6365 6.23186 11.5573 5.7102 11.8307 5.33936C12.1032 4.96853 12.6248 4.88936 12.9957 5.1627L12.999 5.1652C13.119 5.25603 13.4682 5.51936 13.6648 5.67353C14.0632 5.98353 14.5957 6.41103 15.1315 6.87603C15.6623 7.33686 16.2148 7.85186 16.6415 8.33436C16.854 8.57436 17.0532 8.82686 17.2032 9.07603C17.339 9.30186 17.5015 9.63103 17.5015 10.0002C17.5015 10.3694 17.339 10.6985 17.2032 10.9244C17.0532 11.1735 16.854 11.426 16.6415 11.666C16.2148 12.1485 15.6623 12.6635 15.1315 13.1244C14.5957 13.5894 14.0632 14.0169 13.6648 14.3269C13.4682 14.481 13.119 14.7444 12.999 14.8352L12.9957 14.8377C12.6248 15.111 12.1032 15.0319 11.8307 14.661C11.5573 14.2902 11.6365 13.7685 12.0073 13.496C12.1182 13.4119 12.4482 13.1627 12.6398 13.0135C13.0232 12.7135 13.5323 12.3052 14.0382 11.866C14.549 11.4227 15.0382 10.9644 15.3923 10.5627C15.5707 10.361 15.734 10.1294 15.8115 10.0002Z"
      fill="white"
    />
  </svg>
);

const checkIcn = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.71Z"
      fill="currentColor"
      fillOpacity="1"
    />
  </svg>
);
